namespace $ {

	$mol_style_define( $bog_invest_app, {
	})

}
